import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowRight } from "lucide-react";
import { OFFER_DOMAINS } from "@/config/branding";

export function Markdown({ children, className = "", onOfferClick, ...rest }) {
  return (
    <div className={`mm-prose ${className}`} {...rest}>
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
        components={{
          a: ({ node, href, children: kids, ...props }) => {
            const isOffer = OFFER_DOMAINS.some((d) => (href || "").includes(d));
            if (isOffer) {
              return (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="offer-link"
                  onClick={() => onOfferClick && onOfferClick(href)}
                  className="flex w-fit items-center gap-2 my-3 px-5 py-3 rounded-2xl bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold no-underline transition-colors"
                >
                  {kids}
                  <ArrowRight className="h-4 w-4" />
                </a>
              );
            }
            return (
              <a {...props} href={href} target="_blank" rel="noreferrer" className="text-emerald-400 underline">
                {kids}
              </a>
            );
          },
          table: ({ node, ...props }) => (
            <div className="overflow-x-auto my-3"><table {...props} className="w-full text-sm border-collapse" /></div>
          ),
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
